<template>
<div class="component">

    <div class="ressources">

        <table class="table is-fullwidth">
            <tr>
                <th>{{$t('enaq_translation_ressources_ressource')}}</th>
                <th>{{$t('enaq_translation_ressources_state')}}</th>
                <th>{{$t('enaq_translation_ressources_free_when')}}</th>
                <th></th>
            </tr>
            <tr v-for="ressource in ressources" class="ressourcetable">
                <td>{{ressource.title}}</td>

                <td v-if="ressource.available" class="has-text-success	has-text-weight-bold	">{{$t('enaq_translation_ressources_free')}}</td>
                <td v-else class="has-text-danger	has-text-weight-bold">{{$t('enaq_translation_ressources_not_free')}}</td>

                <td v-if="ressource.available" class="has-text-success	">{{$t('enaq_translation_ressources_free_now')}}</td>
                <td v-else>{{formatDate(ressource.openTimespots[1].begin)[0]}}, {{formatDate(ressource.openTimespots[1].begin)[1]}}</td>

                <td class="has-text-link has-text-weight-bold	booklink" @click="openBookRessourceModal(ressource)" v-if="getBookedTimeframeForUser(ressource)==null"><i class="fas fa-edit"></i> {{$t('enaq_translation_ressources_book')}}</td>
                <td @click="openEditRessourceModal(ressource)" v-else class="has-text-weight-bold	"><i class="fas fa-edit"></i> {{$t('enaq_translation_ressources_is_booked')}}</td>

            </tr>
        </table>
    </div>

    <div class="modal is-active" v-if="ressourceToBook!=null">
        <div class="modal-background" @click="closeModal()"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{$t('enaq_translation_ressources_book_ressource')}}</p>
                <button class="delete" aria-label="close" @click="closeModal()"></button>
            </header>
            <section class="modal-card-body bookRessourceModal ">
                <div class="columns is-mobile is-multiline">
                    <label class="label column is-3">{{$t('enaq_translation_ressources_book_ressource_date')}}</label>
                    <datepicker :disabledDates="disabledDates" class="column is-9-desktop is-12-mobile" input-class="input" v-model="eventDate"></datepicker>
                </div>
                <div class="columns is-mobile is-multiline" v-if="openTimeSpots!=null">

                    <label class="label column is-3">{{$t('enaq_translation_ressources_book_ressource_from')}}</label>

                    <div class="select column is-3" v-if="openTimeSpots!=null">
                        <select v-model="beginHourToBook">
                            <option v-for="(hour, index) in openTimeSpots.hours" :value="hour" v-if="openTimeSpots.hours[index+1] == openTimeSpots.hours[index]+1 ">{{hour}} </option>
                        </select>
                    </div>

                    <label class="label column is-3" v-if="openTimeSpots!=null && beginHourToBook!=null">{{$t('enaq_translation_ressources_book_ressource_until')}}</label>

                    <div class="select column is-3 is-arrowless" v-if="openTimeSpots!=null && beginHourToBook!=null">
                        <select v-model="endHourToBook">
                            <option v-for="(hour, index) in endHours" :value="hour">{{hour}} </option>
                        </select>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-success" @click="bookRessource()">{{$t('enaq_translation_ressources_book_ressource_submit')}}</button>
                <button class="button" @click="closeModal()">{{$t('enaq_translation_ressources_book_ressource_cancel')}}</button>
            </footer>
        </div>

    </div>
    <div class="modal is-active" v-if="bookedRessourceToEdit!=null">
        <div class="modal-background" @click="closeModal()"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{$t('enaq_translation_ressources_cancel_booking_title')}}</p>
                <button class="delete" aria-label="close" @click="closeModal()"></button>
            </header>
            <section class="modal-card-body">
                <table class="table">
                    <tr>
                        <th>{{$t('enaq_translation_ressources_cancel_booking_date')}}</th>
                        <th>{{$t('enaq_translation_ressources_cancel_booking_from')}}</th>
                        <th>{{$t('enaq_translation_ressources_cancel_booking_until')}}</th>
                        <th></th>
                    </tr>
                    <tr>
                        <td>{{bookedTimeframe.date}}</td>
                        <td>{{bookedTimeframe.begin}}</td>
                        <td> {{bookedTimeframe.end}}</td>
                        <td>
                            <div class="button is-danger" @click="deleteBooking(bookedTimeframe.calendar_id)">{{$t('enaq_translation_ressources_cancel_booking_submit')}}</div>
                        </td>
                    </tr>
                </table>

            </section>
            <footer class="modal-card-foot">

                <button class="button" @click="closeModal()">{{$t('enaq_translation_ressources_cancel_booking_cancel')}}</button>
            </footer>
        </div>
    </div>

</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

export default {
    name: 'Ressources',
    props: [],
    mounted: function () {
        this.getRessources();
    },
    components: {
        Datepicker,
        moment
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            ressources: [],
            ressourceToBook: null,
            bookedRessourceToEdit: null,
            bookedTimeframe: null,
            eventDate: null,
            beginHourToBook: null,
            endHourToBook: null,
            disabledDates: {
                to: new Date(Date.now() - 8640000)
            },
        }
    },
    methods: {

        getRessources() {
            this.ressources = [];
            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }
            let postData = {}
            this.$axios.get(this.$backendURL + "/ressource/all", {
                headers: headerData
            }).then(function (result) {
                this.ressources = result.data.ressources
            }.bind(this))
        },

        openBookRessourceModal(ressource) {
            this.ressourceToBook = ressource;
            // alert(ressource)
        },
        openEditRessourceModal(ressource) {
            let bookedFrame = this.getBookedTimeframeForUser(ressource)
            let bookedDate = moment(bookedFrame.begin).format('YYYY-MM-DD');
            let bookedHourBegin = moment(bookedFrame.begin).format('H')
            let bookedHourEnd = moment(bookedFrame.end).format('H')

            this.bookedTimeframe = {
                "date": bookedDate,
                "begin": bookedHourBegin,
                "end": bookedHourEnd,
                "calendar_id": bookedFrame.id
            };
            this.bookedRessourceToEdit = ressource;
        },
        getBookedTimeframeForUser(ressource) {
            if (ressource.calendar.length == 0 || ressource.calendar == null) {
                return null;
            }
            for (var i = 0; i < ressource.calendar.length; i++) {
                if (ressource.calendar[i].pivot.user_id == this.$store.getters.getUser.id) {
                    return ressource.calendar[i];
                }
            }
            return null;
        },
        deleteBooking(calendar_id) {
            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }
            let postData = {
                'calendar_id': calendar_id + ""
            }
            this.$axios.post(this.$backendURL + "/ressource/booking/cancel", postData, {
                headers: headerData
            }).then(function (result) {
                this.bookedRessourceToEdit = null;
                this.getRessources();
            }.bind(this))
        },
        closeModal() {
            this.ressourceToBook = null;
            this.beginHourToBook = null;
            this.endHourToBook = null;
            this.eventDate = null;
            this.ressourceToBook = null;
            this.bookedRessourceToEdit = null;
        },
        bookRessource() {
            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }
            var bookDate = moment(this.eventDate).format('YYYY-MM-DD')

            let postData = {
                'begin': bookDate + " " + this.parseHour(this.beginHourToBook) + ":00:00",
                'end': bookDate + " " + this.parseHour(this.endHourToBook) + ":00:00"

            }
            this.$axios.post(this.$backendURL + "/ressource/" + this.ressourceToBook.id + "/book", postData, {
                headers: headerData
            }).then(function (result) {
                this.ressourceToBook = null;
                this.beginHourToBook = null;
                this.endHourToBook = null;
                this.eventDate = null;
                this.getRessources();
            }.bind(this))
        },
        parseHour(hour) {
            hour = hour + ""
            console.log("hourlength for '" + hour + "' : " + hour.length)
            if (hour.length == 1) {
                return "0" + hour
            } else {
                return hour;
            }
        },
        formatDate(date) {
            var formattedDate = new Date(date);
            var dateValues = []
            var options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric',

            };
            dateValues.push(formattedDate.toLocaleDateString('de-DE', options))
            var optionsH = {
                hour: 'numeric',
            };
            dateValues.push(formattedDate.getHours() + " " + this.$t('enaq_translation_events_hour'))

            return dateValues;
        }
    },
    computed: {
        openTimeSpots() {

            let openTimeSlots = {
                "hours": [],
                "possibleTimeSlots": []
            }
            let possibleTimeSlots = [];

            //Die vom Server übergebenen Timeslots zeigen die Daten, an denen Ressourcen gebucht werden können (Zwischen Start und end)
            //Der letzte zeigt nur an ab wann die ressource frei ist und hat kein Ende(Da danach noch keine Buchung ist)
            if (this.ressourceToBook == null || this.eventDate == null) {

                return null;
            }

            if (this.ressourceToBook.openTimespots.length <= 0) {
                for (var hour = 0; hour < 24; hour++) {
                    openTimeSlots.hours.indexOf(hour) === -1 ? openTimeSlots.hours.push(hour) : console.log("This item already exists +hour");

                }
                return openTimeSlots;
            }

            //Speichere den gewünschten Tag
            let dateString = moment(this.eventDate).format('YYYY-MM-DD')
            let foundTimeslotForToday = false;
            //Gehe jeden möglichen freien Timespot für die Ressource durch
            for (var index = 0; index < this.ressourceToBook.openTimespots.length; index++) {
                var timespot = this.ressourceToBook.openTimespots[index];

                var timespotBegin = moment(timespot.begin).format('YYYY-MM-DD')
                var timespotEnd = moment(timespot.end).format('YYYY-MM-DD')

                //Prüfe, ob der Timespot für den heutigen Tag gilt
                if (timespotBegin <= dateString && (timespotEnd >= dateString || timespot.end == null)) {
                    foundTimeslotForToday = true;
                    possibleTimeSlots.push(timespot)
                    var beginHour = parseInt(moment(timespot.begin).format('H'))
                    //Ist der Timeslot der letzte(end == null)?
                    if (timespot.end == null) {
                        //Beginnt der Timeslot heute? Wenn nicht ist er bspw seit tagen frei
                        if (timespotBegin == dateString) {
                            for (var hour = beginHour; hour < 24; hour++) {
                                openTimeSlots.hours.indexOf(hour) === -1 ? openTimeSlots.hours.push(hour) : console.log("This item already exists +hour");

                            }
                        } else {
                            for (var hour = 0; hour < 24; hour++) {
                                openTimeSlots.hours.indexOf(hour) === -1 ? openTimeSlots.hours.push(hour) : console.log("This item already exists +hour");

                            }
                        }

                    } else {
                        var endHour = parseInt(moment(timespot.end).format('H'))
                        console.log(endHour)
                        for (var hour = beginHour; hour <= endHour; hour++) {
                            openTimeSlots.hours.indexOf(hour) === -1 ? openTimeSlots.hours.push(hour) : console.log("This item already exists +hour");
                        }
                    }
                }

            }

            if (this.ressourceToBook.openTimespots.length <= 0 || !foundTimeslotForToday) {
                for (var hour = 0; hour < 24; hour++) {
                    openTimeSlots.hours.indexOf(hour) === -1 ? openTimeSlots.hours.push(hour) : console.log("This item already exists +hour");

                }
                return openTimeSlots;
            }

            openTimeSlots.possibleTimeSlots = possibleTimeSlots;
            return openTimeSlots;

        },
        endHours() {
            if (this.beginHourToBook == null || this.openTimeSpots == null) {
                return
            } else {
                let possibleHours = []

                for (var i = 0; i <= this.openTimeSpots.hours.length - 1; i++) {
                    if (this.openTimeSpots.hours[i] <= this.beginHourToBook) {

                        continue
                    } else if (this.openTimeSpots.hours[i + 1] != this.openTimeSpots.hours[i] + 1 && i != this.openTimeSpots.hours.length - 1) {
                        possibleHours.push(this.openTimeSpots.hours[i])

                        break;
                    } else {

                        possibleHours.push(this.openTimeSpots.hours[i])
                    }

                }
                return possibleHours;

            }
        }
    },
}
</script>

<style scoped>
.bookRessourceModal {
    min-height: 50vh;
}

/*Remove arrow from bulma-select*/
.select:not(.is-multiple):not(.is-loading)::after {
    display: none;
}

.booklink {
    cursor: pointer;
}
</style>
